import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { CandidateTypes } from "@/Components/common/client/candidates/CandidateTypes";
import { AppliedList } from "@/Components/common/client/candidates/Listing/AppliedList";
import {
  fetchAppliedCandidates,
  setAppliedCandidatesLoading,
  updatePagination,
  deSelectAllCandidate,
  updateFilters,
} from "@/reducers/client_candidates/candidatesapplied";
import { updateactivePages } from "@/reducers/clientcommon";
import useTitle from "@/utilities/hooks/useTitle";

/**
 * Renders the Applied component with the provided session data.
 *
 * @return {JSX.Element} the rendered Applied component
 */
const Applied = () => {
  useTitle("Applied Candidates");
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesApplied,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }

    // dispatch(fetchClientPublishBankContract());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAppliedCandidatesLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchAppliedCandidates());
    dispatch(
      updateactivePages({
        activePage: "candidates",
        activeSubPage: "applied",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
  }, []);
  return (
    <>
      {/* <AppliedDatesModal /> */}
      <div className="flex flex-col gap-4">
        <CandidateTypes />
        <AppliedList />
      </div>
    </>
  );
};

export default Applied;
